import * as React from "react"
import {LocaleContext, LocationContext} from "../context"
import { graphql, useStaticQuery } from "gatsby"
import { localizedPath } from "../helpers"

const useLocalization = () => {
  const locale = React.useContext(LocaleContext)
  const { pathname } = React.useContext(LocationContext);
  const basePath = pathname.replace(new RegExp(`^/${locale}`), "")

  const {
    themeI18N: { defaultLang, prefixDefault, config },
  } = useStaticQuery(graphql`
    query LocalizationConfigQuery {
      themeI18N {
        defaultLang
        prefixDefault
        config {
          code
          hrefLang
          dateFormat
          langDir
          localName
          name
        }
      }
    }
  `)

  return {
    locale,
    defaultLang,
    prefixDefault,
    config,
    basePath,
    localizedPath,
  }
}

export { useLocalization }
